const config = {
    imageSizes: {
        thumbnail: 160,
        logo: 320,
        xs: 240,
        m: 540,
        l: 720,
        xl: 1080,
        xxl: 1440
    },
    likes: {
        limit: 20
    },
    comments: {
        limit: 20,
        replies: {
            limit: 5
        }
    },
    notifications: {
        limit: 20,
        excerpt: {
            max: 30
        }
    },
    peopleDirectory: {
        limit: 20,
        paging: {
            max: 7
        },
        autoComplete: {
            enabled: true,
            minChars: 2,
            delay: 300,
            limit: 5
        }
    }
}

export default config;